import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import Navbar from './Navbar';
import Footer from './Footer';
import { mediaUrl } from '../utils/media';

const TermsPage: React.FC = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
    });

    const spinner = document.getElementById('spinner');
    if (spinner) {
      setTimeout(() => {
        spinner.classList.remove('show');
      }, 500);
    }

    const backToTop = document.querySelector('.back-to-top');
    if (backToTop) {
      const handleScroll = () => {
        if (window.scrollY > 300) {
          (backToTop as HTMLElement).style.display = 'block';
        } else {
          (backToTop as HTMLElement).style.display = 'none';
        }
      };

      window.addEventListener('scroll', handleScroll);

      backToTop.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  return (
    <>
      <div
        id="spinner"
        className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
      >
        <div className="spinner-grow text-primary" role="status"></div>
      </div>

      <Navbar />

      <div
        className="container-fluid page-header mb-5"
        data-aos="fade"
        data-aos-delay="100"
        style={{ background: `linear-gradient(rgba(0, 29, 35, .8), rgba(0, 29, 35, .8)), url(${mediaUrl('carousel-1.jpg')}) center center / cover no-repeat` }}
      >
        <div className="container text-center">
          <h1 className="display-4 text-white animated slideInDown mb-4" data-aos="fade-down">Terms &amp; Conditions</h1>
          <nav aria-label="breadcrumb animated slideInDown" data-aos="fade-down" data-aos-delay="200">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item">
                <Link to="/" className="text-white">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="text-white">Pages</span>
              </li>
              <li className="breadcrumb-item text-primary active" aria-current="page">
                Terms &amp; Conditions
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10" data-aos="fade-up" data-aos-delay="100">
              <div className="bg-light rounded p-5">
                <h2 className="display-6 mb-4">Terms &amp; Conditions</h2>
                <p className="text-muted mb-4"><small>Last updated on 06 June 2026</small></p>

                <p className="mb-4">
                  These Terms and Conditions, along with privacy policy or other terms (&quot;Terms&quot;) constitute a binding agreement by and between HUMANITY TRUST, (&quot;Website Owner&quot; or &quot;we&quot; or &quot;us&quot; or &quot;our&quot;) and you (&quot;you&quot; or &quot;your&quot;) and relate to your use of our website, goods (as applicable) or services (as applicable) (collectively, &quot;Services&quot;).
                </p>

                <p className="mb-4">
                  By using our website and availing the Services, you agree that you have read and accepted these Terms (including the Privacy Policy). We reserve the right to modify these Terms at any time and without assigning any reason. It is your responsibility to periodically review these Terms to stay informed of updates.
                </p>

                <p className="mb-3"><strong>The use of this website or availing of our Services is subject to the following terms of use:</strong></p>

                <ul className="mb-4" style={{ lineHeight: '2' }}>
                  <li className="mb-3">
                    To access and use the Services, you agree to provide true, accurate and complete information to us during and after registration, and you shall be responsible for all acts done through the use of your registered account.
                  </li>
                  <li className="mb-3">
                    Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials offered on this website or through the Services, for any specific purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.
                  </li>
                  <li className="mb-3">
                    Your use of our Services and the website is solely at your own risk and discretion. You are required to independently assess and ensure that the Services meet your requirements.
                  </li>
                  <li className="mb-3">
                    The contents of the Website and the Services are proprietary to Us and you will not have any authority to claim any intellectual property rights, title, or interest in its contents.
                  </li>
                  <li className="mb-3">
                    You acknowledge that unauthorized use of the Website or the Services may lead to action against you as per these Terms or applicable laws.
                  </li>
                  <li className="mb-3">
                    You agree to pay us the charges associated with availing the Services.
                  </li>
                  <li className="mb-3">
                    You agree not to use the website and/or Services for any purpose that is unlawful, illegal or forbidden by these Terms, or Indian or local laws that might apply to you.
                  </li>
                  <li className="mb-3">
                    You agree and acknowledge that website and the Services may contain links to other third party websites. On accessing these links, you will be governed by the terms of use, privacy policy and such other policies of such third party websites.
                  </li>
                  <li className="mb-3">
                    You understand that upon initiating a transaction for availing the Services you are entering into a legally binding and enforceable contract with us for the Services.
                  </li>
                  <li className="mb-3">
                    Donations and other online payments are processed through Cashfree&apos;s secure payment gateway. By proceeding with payment, you also agree to Cashfree&apos;s terms, policies, and banking network rules applicable to your selected payment method.
                  </li>
                  <li className="mb-3">
                    After a successful donation, a payment confirmation/receipt reference (such as Cashfree Payment ID or Transaction ID) will be generated. You are requested to retain this reference for support, reconciliation, or refund-related communication.
                  </li>
                  <li className="mb-3">
                    You shall be entitled to claim a refund of the payment made by you in case we are not able to provide the Service. The timelines for such return and refund will be according to the specific Service you have availed or within the time period provided in our policies (as applicable). In case you do not raise a refund claim within the stipulated time, then this would make you ineligible for a refund.
                  </li>
                  <li className="mb-3">
                    Notwithstanding anything contained in these Terms, the parties shall not be liable for any failure to perform an obligation under these Terms if performance is prevented or delayed by a force majeure event.
                  </li>
                  <li className="mb-3">
                    These Terms and any dispute or claim relating to it, or its enforceability, shall be governed by and construed in accordance with the laws of India.
                  </li>
                  <li className="mb-3">
                    All disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts in Kamalnagar, Karnataka.
                  </li>
                  <li className="mb-3">
                    All concerns or communications relating to these Terms must be communicated to us using the contact information provided on this website.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <button type="button" className="btn btn-lg btn-primary btn-lg-square back-to-top" aria-label="Back to top">
        <i className="bi bi-arrow-up"></i>
      </button>
    </>
  );
};

export default TermsPage;
